<!--
@component
Site footer with logo, links and social icons.
-->
<script lang="ts">
  import GithubIcon from "$lib/assets/logos/socials/GithubLogo.svelte";
  import Linkedin from "$lib/assets/logos/socials/LinkedinLogo.svelte";
  import XLogo from "$lib/assets/logos/socials/XLogo.svelte";
  import logoBlack from "$lib/assets/modal-logo-black.svg";
</script>

<!-- This margin element is separate from the element below, and it disables pointer interactions. -->
<div class="pointer-events-none mt-24"></div>

<!-- 72rem fits the logotype, links, and social icons on one line. -->
<footer class="@container mt-auto">
  <div
    class="flex flex-col gap-y-[27px] border-t border-secondary px-4 py-5 @min-[72rem]:flex-row @min-[72rem]:items-center"
  >
    <div class="flex min-h-5 items-center gap-x-3">
      <img src={logoBlack} alt="Modal" class="logotype h-3" />
    </div>
    <div
      class="grid grid-cols-2 gap-x-5 gap-y-3 sm:grid-cols-4 @min-[72rem]:ml-auto @min-[72rem]:flex"
    >
      <a
        class="link"
        href="https://status.modal.com/"
        target="_blank"
        rel="noopener noreferrer">Status</a
      >
      <a
        class="link"
        href="/changelog"
        target="_blank"
        rel="noopener noreferrer">Changelog</a
      >
      <a
        class="link"
        href="/docs/sdk/py/releases"
        target="_blank"
        rel="noopener noreferrer">Releases</a
      >
      <a
        class="link"
        href="/docs/guide"
        target="_blank"
        rel="noopener noreferrer">Docs</a
      >
      <a class="link" href="/slack" target="_blank" rel="noopener noreferrer"
        >Slack Community</a
      >
      <a class="link" href="/pricing" target="_blank" rel="noopener noreferrer"
        >Pricing</a
      >
      <a
        class="link"
        href="/docs/examples"
        target="_blank"
        rel="noopener noreferrer">Examples</a
      >
    </div>
    <div
      class="flex items-center gap-4 @min-[72rem]:ml-7 @min-[72rem]:h-4 @min-[72rem]:border-l @min-[72rem]:border-secondary @min-[72rem]:pl-7"
    >
      <a
        href="https://www.linkedin.com/company/modal-labs/"
        target="_blank"
        rel="noreferrer"
        class="social-link"
      >
        <Linkedin size={13} class="fill-current stroke-none" />
      </a>
      <a
        href="https://x.com/modal"
        target="_blank"
        rel="noreferrer"
        class="social-link"
      >
        <XLogo size={15} class="fill-current stroke-none" />
      </a>
      <a
        href="https://github.com/modal-labs"
        target="_blank"
        rel="noreferrer"
        class="social-link -ml-[3px]"
      >
        <GithubIcon
          size={18.5}
          class="-translate-y-px fill-current stroke-none"
        />
      </a>
    </div>
  </div>
</footer>

<style lang="postcss">
  @reference "$app.css";

  .link {
    @apply text-xs text-secondary transition-colors hover:text-secondary-hover;
  }

  .social-link {
    @apply icon-secondary transition-colors hover:icon-secondary-hover;
  }

  .logotype {
    filter: invert(1);
  }

  :global([data-theme="light"]) .logotype {
    filter: none;
  }
</style>
